/** Chave única no localStorage (versionada para migrações futuras). */
export const FAVORITE_BETS_STORAGE_KEY = 'kickstats_favorite_bets_v1';

/** Odd decimal válida para múltipla (margem mínima). */
export function isValidDecimalOdd(n) {
  const x = typeof n === 'number' ? n : Number(n);
  return Number.isFinite(x) && x > 1.01;
}

export function buildFavoriteFromSuggestionBet(bet) {
  const idBase =
    bet?.id != null && String(bet.id) !== ''
      ? String(bet.id)
      : `${bet?.fixture_id ?? ''}-${bet?.team1_id ?? ''}-${bet?.team2_id ?? ''}-${String(bet?.market ?? '').slice(0, 80)}`;
  const id = `sug-${idBase}`;
  const label = `${bet.match || `${bet.team1_name || ''} x ${bet.team2_name || ''}`.trim()} — ${bet.market || 'Mercado'}`;
  const decimalOdd = bet.odds_est ?? bet.odds_estimate ?? bet.odds ?? null;
  return {
    id,
    label: label.replace(/\s+/g, ' ').trim(),
    decimalOdd: decimalOdd != null && Number.isFinite(Number(decimalOdd)) ? Number(decimalOdd) : null,
    source: 'suggestion',
    createdAt: new Date().toISOString(),
    team1_id: bet.team1_id,
    team2_id: bet.team2_id,
    fixture_id: bet.fixture_id,
  };
}

/** Pernas do carrossel de bilhetes → payloads únicos para a Gestão (mesmo formato que sugestão isolada). */
export function buildFavoritePayloadsFromBilheteLegs(legs) {
  if (!Array.isArray(legs) || legs.length === 0) return [];
  const seen = new Set();
  const out = [];
  for (const bet of legs) {
    const payload = buildFavoriteFromSuggestionBet(bet);
    if (!payload?.id || !payload.label) continue;
    if (seen.has(payload.id)) continue;
    seen.add(payload.id);
    out.push(payload);
  }
  return out;
}

export function buildFavoriteFromPrediction(p) {
  const id = `pred-${p.prediction_id}`;
  const r =
    p.predicted_result === 'team1'
      ? 'Vitória casa'
      : p.predicted_result === 'team2'
        ? 'Vitória fora'
        : 'Empate';
  const label = `${p.team1_name} vs ${p.team2_name} — Palpite: ${r}`;
  return {
    id,
    label,
    decimalOdd: null,
    source: 'prediction',
    createdAt: new Date().toISOString(),
    team1_id: p.team1_id,
    team2_id: p.team2_id,
  };
}

/** Mercado sugerido na análise de confronto (aba Mercados / compacto). */
export function buildFavoriteFromAnalysisMarketSuggestion({
  fixtureId,
  team1_id,
  team2_id,
  team1_name,
  team2_name,
  market,
  category,
  index,
  odds_estimate,
  odds_est,
}) {
  const id =
    fixtureId != null
      ? `amkt-fx-${String(fixtureId)}-${Number(index)}`
      : team1_id && team2_id
        ? `amkt-t${team1_id}-${team2_id}-${Number(index)}`
        : `amkt-i${Number(index)}`;
  const match = `${team1_name || ''} x ${team2_name || ''}`.replace(/\s+/g, ' ').trim();
  const est = odds_estimate ?? odds_est;
  const decimalOdd =
    est != null && Number.isFinite(Number(est)) ? Number(est) : null;
  return {
    id,
    label: `${match} — ${market || 'Mercado'}`.replace(/\s+/g, ' ').trim(),
    decimalOdd,
    source: 'analysis_market',
    createdAt: new Date().toISOString(),
    team1_id,
    team2_id,
    fixture_id: fixtureId ?? null,
    category: category || null,
    market: market || null,
  };
}

/** Odd agregada ou por casa na análise (aba Odds / compacto). */
export function buildFavoriteFromAnalysisOddSelection({
  fixtureId,
  team1_id,
  team2_id,
  team1_name,
  team2_name,
  selectionKey,
  selectionLabel,
  decimalOdd,
}) {
  const idPrefix =
    fixtureId != null
      ? `aodd-fx-${String(fixtureId)}`
      : team1_id && team2_id
        ? `aodd-t${team1_id}-${team2_id}`
        : 'aodd-na';
  const safeKey = String(selectionKey || 'k')
    .replace(/[^a-zA-Z0-9_-]/g, '')
    .slice(0, 96);
  const id = `${idPrefix}-${safeKey}`;
  const match = `${team1_name || ''} x ${team2_name || ''}`.replace(/\s+/g, ' ').trim();
  const n = typeof decimalOdd === 'number' ? decimalOdd : Number(decimalOdd);
  return {
    id,
    label: `${match} — ${selectionLabel}`.replace(/\s+/g, ' ').trim(),
    decimalOdd: Number.isFinite(n) ? n : null,
    source: 'analysis_odds',
    createdAt: new Date().toISOString(),
    team1_id,
    team2_id,
    fixture_id: fixtureId ?? null,
  };
}

/** Sugestão do modelo no detalhe ao vivo (livescores). */
export function buildFavoriteFromLiveBetSuggestion({
  fixtureId,
  team1_id,
  team2_id,
  team1_name,
  team2_name,
  market,
  category,
  index,
  decimalOdd,
}) {
  const fx = fixtureId != null ? String(fixtureId) : 'na';
  const id = `livebet-${fx}-${Number(index)}`;
  const match = `${team1_name || ''} x ${team2_name || ''}`.replace(/\s+/g, ' ').trim();
  const n = typeof decimalOdd === 'number' ? decimalOdd : Number(decimalOdd);
  return {
    id,
    label: `${match} — ${market || 'Mercado'}`.replace(/\s+/g, ' ').trim(),
    decimalOdd: Number.isFinite(n) ? n : null,
    source: 'live_suggestion',
    createdAt: new Date().toISOString(),
    team1_id,
    team2_id,
    fixture_id: fixtureId ?? null,
    category: category || null,
    market: market || null,
  };
}
